import { Popover as BasePopover } from "@base-ui-components/react/popover";
import { BellIcon } from "lucide-react";
import {
  popoverTriggerClasses,
  popOverPopupClasses,
  popoverArrowClasses,
  popoverTitleClasses,
  popoverDescriptionClasses,
} from "./Popover.style";
import React from "react";
import ArrowSvg from "@/common/ArrowSvg";

export type PopperProps = BasePopover.Root.Props & {
  children?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
  anchorEl?: HTMLElement | null;
  side?: BasePopover.Positioner.Props["side"];
  align?: BasePopover.Positioner.Props["align"];
  trigger?: React.ReactElement;
  disabled?: BasePopover.Trigger.Props["disabled"];
};

const Popover: React.FC<PopperProps> = (props) => {
  const {
    children,
    className,
    anchorEl,
    side = "bottom",
    align = "center",
    title,
    description,
    trigger,
    disabled,
    ...rest
  } = props;
  return (
    <BasePopover.Root {...rest}>
      {trigger ? (
        <BasePopover.Trigger
          disabled={disabled}
          className={popoverTriggerClasses()}
          render={({ className: _, ...props }) =>
            React.cloneElement(trigger, props)
          }
        />
      ) : (
        <BasePopover.Trigger
          disabled={disabled}
          className={popoverTriggerClasses()}
        >
          <BellIcon aria-label="Notifications" />
        </BasePopover.Trigger>
      )}

      <BasePopover.Portal>
        <BasePopover.Positioner
          sideOffset={8}
          anchor={anchorEl}
          side={side}
          align={align}
        >
          <BasePopover.Popup
            className={popOverPopupClasses({ class: className })}
          >
            <BasePopover.Arrow className={popoverArrowClasses()}>
              <ArrowSvg />
            </BasePopover.Arrow>
            {title && (
              <BasePopover.Title className={popoverTitleClasses()}>
                {title}
              </BasePopover.Title>
            )}

            {description && (
              <BasePopover.Description className={popoverDescriptionClasses()}>
                {description}
              </BasePopover.Description>
            )}
            {children}
          </BasePopover.Popup>
        </BasePopover.Positioner>
      </BasePopover.Portal>
    </BasePopover.Root>
  );
};

export default Popover;
